import { MaterialIcon } from "@website/icons/material";
import { CounterButtonPropertiesType } from "@website/ui/counter-button/counter-button.types";
import { numberConvert } from "@website/utils/number-convert";
import { useCallback, useEffect } from "react";

export const useCounterButton = (properties: CounterButtonPropertiesType) => {
  const {
    color,
    decreaseDisabled,
    increaseDisabled,
    onChange,
    value = 0,
    variant,
    locale,
    "aria-label": ariaLabel
  } = properties;

  const onDecreaseButtonClick = useCallback(() => {
    onChange?.(value - 1);
  }, [value, onChange]);

  const onIncreaseButtonClick = useCallback(() => {
    onChange?.(value + 1);
  }, [value, onChange]);

  useEffect(() => {
    if (value === undefined) onChange?.(0);
  }, [onChange, value]);

  return {
    value: numberConvert(value, { locale: locale || "en" }) || 0,
    rootProps: {},
    decreaseButtonProps: {
      "aria-label": ariaLabel ? `${"کاهش"} ${ariaLabel}` : "decrease button",
      color,
      disabled: decreaseDisabled,
      EndIcon: <MaterialIcon name="remove" />,
      onClick: onDecreaseButtonClick,
      equalDimension: true,
      variant
    },
    valueProps: {
      "aria-label": ariaLabel || undefined
    },
    increaseButtonProps: {
      "aria-label": ariaLabel ? `${"افزایش"} ${ariaLabel}` : "increase button",
      color,
      disabled: increaseDisabled,
      EndIcon: <MaterialIcon name="add" />,
      onClick: onIncreaseButtonClick,
      equalDimension: true,
      variant
    }
  };
};
